// React
import React, { useState } from "react";
import PropTypes from "prop-types";

// Components
import CheckboxesVertical from "../checkboxes/CheckboxesVertical";

// Functions
import { translate } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";
import { AutoCloseModal } from "../modal/Modal";

// Styling
import "./TableMenuOptions.css";

TableMenuOptions.propTypes = {
  selectedColumns: PropTypes.array,
  setSelectedColumns: PropTypes.func,
  setModal: PropTypes.func,
  moduleId: PropTypes.string,
  tableName: PropTypes.string,
  columnKeys: PropTypes.array,
  maxNoColumnsAllowed: PropTypes.number,
  configTableColumns: PropTypes.object,
};

export default function TableMenuOptions(props) {
  // Modal
  const { setModal } = props;

  // Props for API
  const { moduleId } = props;
  const { tableName } = props;

  // Settings
  const { maxNoColumnsAllowed } = props;

  // Data
  const { columnKeys } = props;
  const { configTableColumns } = props;

  const { selectedColumns, setSelectedColumns } = props;

  const [error, setError] = useState();

  let maximumColumnsNote = "";

  if (isEmpty(maxNoColumnsAllowed)) {
    maximumColumnsNote = "No Limit";
  } else {
    maximumColumnsNote = maxNoColumnsAllowed;
  }

  return (
    <div className="table-options-menu-container">
      <div className="table-options-menu-button">
        <div className="table-options-menu-body">
          <div className="table-options-menu-list">
            <div>
              {"Maximum number of columns allowed:"} {maximumColumnsNote}
            </div>
            <div>
              {"Current number of columns selected:"} {selectedColumns?.length}
            </div>
            <CheckboxesVertical
              array={columnKeys}
              setFunction={setSelectedColumns}
              selection={selectedColumns}
              // Max Selection
              maxSelectionSize={maxNoColumnsAllowed}
              // Min Selection
              minSelectionSize={1}
            />
          </div>
          <div className="table-options-menu-footer">
            <div className="general-row-container">
              <DisplayError error={error} />
            </div>
            <div className="general-row-container">
              <button
                id="table_options_menu_save"
                className="general-upload-button"
                onClick={async () => {
                  await saveConfigTableColumns(
                    configTableColumns,
                    moduleId,
                    tableName,
                    selectedColumns,
                    setError,
                    setModal
                  );
                }}
              >
                {translate("Save")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
DisplayError.propTypes = {
  error: PropTypes.object,
};
function DisplayError(props) {
  const { error } = props;
  if (isEmpty(error)) return null;

  return (
    <div className="feedback-error-container">
      <div className={error.type}>
        <b>{error.text}</b>
      </div>
    </div>
  );
}

async function saveConfigTableColumns(
  configTableColumns,
  moduleId,
  tableName,
  selectedColumns,
  setError,
  setModal
) {
  setError({
    type: "feedback-success",
    text: "Saving...",
  });

  const success = await configTableColumns.save(
    moduleId,
    tableName,
    selectedColumns
  );

  if (success) {
    setError({
      text: "Saved",
      type: "feedback-success",
    });

    const config = await configTableColumns.get(moduleId, tableName);
    configTableColumns.set(config);

    AutoCloseModal(setModal);
  } else {
    setError({
      text: "Not Saved",
      type: "feedback-error",
    });
  }
}
